var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38623 28.5846C3.38623 14.7314 14.6164 3.50122 28.4696 3.50122C42.3227 3.50122 53.5529 14.7314 53.5529 28.5846C53.5529 42.4377 42.3227 53.6679 28.4696 53.6679C14.6164 53.6679 3.38623 42.4377 3.38623 28.5846ZM28.4696 7.00122C16.5494 7.00122 6.88623 16.6644 6.88623 28.5846C6.88623 40.5047 16.5494 50.1679 28.4696 50.1679C40.3897 50.1679 50.0529 40.5047 50.0529 28.5846C50.0529 16.6644 40.3897 7.00122 28.4696 7.00122Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4696 17.5012C29.4361 17.5012 30.2196 18.2847 30.2196 19.2512V37.9179C30.2196 38.8844 29.4361 39.6679 28.4696 39.6679C27.5031 39.6679 26.7196 38.8844 26.7196 37.9179V19.2512C26.7196 18.2847 27.5031 17.5012 28.4696 17.5012Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3862 28.5846C17.3862 27.6181 18.1697 26.8346 19.1362 26.8346H37.8029C38.7694 26.8346 39.5529 27.6181 39.5529 28.5846C39.5529 29.5511 38.7694 30.3346 37.8029 30.3346H19.1362C18.1697 30.3346 17.3862 29.5511 17.3862 28.5846Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOne);
export default __webpack_public_path__ + "static/media/add-one.377c64c2.svg";
export { ForwardRef as ReactComponent };